module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vueAceEditor', {
    style: (_vm.style),
    attrs: {
      "lang": _vm.language,
      "theme": _vm.theme,
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "init": _vm.editorInit,
      "input": _vm.change
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40876a64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workbench/editor/AceEditor.vue
// module id = 1539
// module chunks = 2